import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ProductInfo from './ProductInfo';
import '../styles/lookup.scss';

export default function ProductInfoModal({ close }) {
  return (
    <div className="modal-backdrop modal-large product-info-modal" onClick={close}>
      <button type="button" className="modal-close" onClick={close}>
        <CloseIcon /> Close
      </button>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="lookup-container product-info-modal-shell">
            <ProductInfo />
          </div>
        </div>
      </div>
    </div>
  );
}
